var React = require('react');

function IcoTime (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15,29.9C6.8,29.9,0.1,23.2,0.1,15S6.8,0.1,15,0.1S29.9,6.8,29.9,15S23.2,29.9,15,29.9z M15,2.1\n      C7.9,2.1,2.1,7.9,2.1,15S7.9,27.9,15,27.9S27.9,22.1,27.9,15S22.1,2.1,15,2.1z","key":0}),React.createElement("rect",{"x":"14","y":"6.7","width":"2","height":"10.7","key":1}),React.createElement("rect",{"x":"14","y":"15.5","width":"8.6","height":"2","key":2})]);
}

IcoTime.defaultProps = {"className":"eind","viewBox":"0 0 30 30","id":"ftime"};

module.exports = IcoTime;

IcoTime.default = IcoTime;
